import { Button, ButtonVariants } from '@comptia-sso/core';
import { ReactElement } from 'react';

// Styles.
import styles from './AccessKeyHeader.module.scss';

export const AccessKeyHeader = (): ReactElement => {
  return (
    <header className={styles.header}>
      <div className={styles.title}>
        <h1>Edit Access Key</h1>
      </div>
      <div className={styles.breadcrumb}>
        <h2 className={styles.subheading}>Looking for another access key?</h2>
        <Button
          className={styles.back}
          link
          to="/access-keys"
          variant={ButtonVariants.Secondary}
        >
          Back to Search
        </Button>
      </div>
    </header>
  );
};
